// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__hJBEI","left":"InfoRow_left__1b8Jn"};